import { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";
import {
  MainContainer,
  Navbar,
  ContentContainer,
  ButtonsSection
} from "./styles";
import { Footer as PlaystationFooter } from "../playstation26/styles";
import logo from "./images/topps-logo.svg";
import splash from "./images/topps-splash.webp";
import digiseqLogo from "./images/digiseq-logo.png";
import shopButton from "./images/shop-button.webp";
import aboutButton from "./images/about-button.webp";
import paymeSwissLogo from "../playstation26/images/payme-swiss-logo.svg";
import copyToClipboard from "../../assets/copy-icon-white.svg";

import packageJson from "../../../package.json";

const Topps26Footer = styled(PlaystationFooter)`
  background-color: #000b83;
`;

const Topps26 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;
  return (
    <MainContainer>
      <Navbar>
        <img src={logo} alt="logo" />
        <div className="balance-container">
          <div className="balance-text">BALANCE</div>
          <div className="balance-value">
            {formattedBalance(
              balanceAndPin?.balanceDetails?.availableBalance,
              balanceAndPin?.balanceDetails?.currency
            )}
          </div>
        </div>
      </Navbar>

      <ContentContainer>
        <img src={splash} alt="splash" />
        <h1>WELCOME TO BUDAPEST!</h1>
        <p>
          Thank you so much for joining the UEFA Champions League Final in
          Budapest with Topps! We hope you are having a marvelous time!
        </p>
        <p>
          The Topps card in your hands is a unique collectible, which doubles as
          Mastercard contactless card, preloaded with €40 to use during the
          final. Just tap the card on a payment terminal to pay like you would
          do with your normal phone or card.
        </p>
        <p>
          To keep the memories going you can reload this card by yourself to
          keep using this Topps card as a payment device after the final. Tap{" "}
          <Link
            target="_blank"
            to={`/curve-account/?serialNumber=${serialNumber}&provider=pannovate`}
          >
            here
          </Link>{" "}
          for details.
        </p>
      </ContentContainer>

      <ButtonsSection>
        <img
          src={shopButton}
          alt="shop-button"
          onClick={() =>
            window.open(
              "https://uk.topps.com/collections/uefa-club-competitions",
              "_blank"
            )
          }
        />
        <img
          src={aboutButton}
          alt="about-button"
          onClick={() =>
            window.open("https://uk.topps.com/pages/uk-about-us", "_blank")
          }
        />
      </ButtonsSection>

      <Topps26Footer>
        <div className="powered-by">Powered by</div>
        <img src={digiseqLogo} alt="digiseq-logo" />
        <p className="payment-provider-label">Payment services provided by</p>
        <img
          className="payme-logo"
          src={paymeSwissLogo}
          alt="payme-swiss-logo"
          onClick={() => window.open("https://paymeswiss.com/", "_blank")}
        />
        <div className="footer-links">
          <a
            href="https://digiseq.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://digiseq.co.uk/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
        </div>
        <div className="copyToClipboard">
          <img
            onClick={() => {
              navigator.clipboard.writeText(serialNumber);
              setCopied(true);
            }}
            src={copyToClipboard}
            alt="copy to clipboard"
          />
          <p>ID: {serialNumber}</p>
        </div>
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </Topps26Footer>
    </MainContainer>
  );
};

export default Topps26;
